<template>
	<div>
		<div class="sliders">
			<div class="slide" v-for="slide in sliders">
				<div class="copy">
					<div class="inner">
						<h2>{{slide.title.value}}</h2>
						<p>{{slide.description.value}}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="pagination">
			<div v-for="slide in sliders">
				<span :class="{active: slide.active_year.value.length}" id="gtm_Timeline-Selection">
					{{slide.year.value}}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name:'Timeline',
		props:['sliders'],
		mounted(){
				$('.sliders').slick({
					slidesToShow: 1,
  					slidesToScroll: 1,
  					 arrows: true,
  					 prevArrow:'<span class="prevArrow"></span>',
  					 nextArrow:'<span class="nextArrow"></span>',
  					 infinite: false,
  					 asNavFor: '.pagination',
  					 responsive: [
					    {
					      breakpoint: 768,
					      settings: {
					        arrows:false
					      }
					    }
					  ]
				});
				$('.pagination').slick({
  					slidesToScroll: 1,
  					slidesToShow: 9,
  					asNavFor: '.sliders',
  					focusOnSelect: true,
			        arrows: false,
			        centerMode: true,
					infinite: false,
  					responsive: [
							{
								breakpoint: 1200,
								settings: {
									slidesToShow: 7,
									centerMode: true,
									centerPadding:0
								}
							},
							{
					      breakpoint: 1024,
					      settings: {
					        slidesToShow: 5,
					        centerMode: true,
					        centerPadding:0
					      }
					    },
							{
					      breakpoint: 768,
					      settings: {
					        slidesToShow: 3,
					        centerMode: true,
					        centerPadding:0
					      }
					    }
					  ]
				});

				var _this = this;



				$('.pagination').on('afterChange', function(event, slick, currentSlide, nextSlide){
					var currentGtmSlide = $(".slick-current span").html();

					_this.$gtm.trackEvent({
					   event: 'click', // Event type [default = 'interaction'] (Optional)
					   category: currentGtmSlide,
					   action: 'click',
					   label: 'Agency',
					   noninteraction: false // Optional
					 });

				});

				//Get active item and Slick Goto
				$('.sliders').slick('slickGoTo',$('.pagination span.active').closest('.slick-slide').attr('data-slick-index'));

		},
	}
</script>



// WEBPACK FOOTER //
// timeline.vue?243b86de